<footer class="footer">
    @if (!demo) {
        <div>
            <div class="footer-bar">
                <div class="brand">
                    <span>&copy; {{ 'FOOTER.info' | translate }}</span> &nbsp; by: &nbsp;
                    <a class="brand-link" href="https://codelabs.rocks/" target="_blank">
                        <img class="brand-logo" src="/assets/images/logo_codelabs.svg" alt="Copyright by codelabs.rocks" />
                    </a>
                </div>
                <div class="footer-address-data">
                    <div class="footer-cell">
                        ul. Północna 22<br />
                        45-805 Opole
                    </div>
                    <div class="footer-cell">
                        <a class="link-default unstyled" href="tel:+48775490100">Tel. +48 77 54 90 100</a><br />
                        <a class="link-default unstyled" href="tel:+48505443215">Kom. +48 505 443 215</a>
                    </div>
                    <div class="footer-cell">
                        <a class="link-default unstyled" href="mailto:biuro@stelmach.pl">biuro&#64;stelmach.pl</a>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div class="footer-bar">
            <div class="brand">
                <span>&copy; {{ footerData?.companyName }}</span> &nbsp; by: &nbsp;
                <a class="brand-link" href="https://codelabs.rocks/" target="_blank">
                    <img class="brand-logo" src="/assets/images/logo_codelabs.svg" alt="Copyright by codelabs.rocks" />
                </a>
            </div>
            <div class="footer-address-data">
                <div class="footer-cell">
                    {{ footerData?.address.street }}<br />
                    {{ footerData?.address.city }}
                </div>
                <div class="footer-cell">
                    <a>{{ footerData?.nip }}</a>
                </div>
            </div>
        </div>
    }
</footer>
